/* Built In Imports */
import NextLink from 'next/link';

/* External Imports */
import { Box, Flex, Link, SimpleGrid } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { refineUrlDomain } from '@components/Utility/utils';

/* Styles */
//Services

/**
 * Renders the Our Offering Component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - data of the section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @param sectionContent.region
 * @param sectionContent.lang
 * @returns {ReactElement} - Our Offering  Component
 */
const SamskritiOfferingCard = ({ sectionContent, region, lang }) => {
  const cards = sectionContent.cards;
  return (
    <Box
      w="100%"
      h="100%"
      paddingBottom="90px"
      backgroundColor="#AF1F22"
      clipPath={{
        base: 'polygon(0 0%, 100% 0, 100% 100%, 0% 98%)',
        lg: 'polygon(0 0%, 100% 0, 100% 100%, 0% 95%)',
      }}
    >
      <Box
        mt="40px"
        mx="auto"
        maxW={{
          base: '302px',
          sm: '480px',
          md: '690px',
          lg: '770px',
          xl: '1170px',
        }}
      >
        <SimpleGrid
          columns={{ base: 1, md: 2, lg: 2, xl: '3' }}
          spacing="15px"
          mx="auto"
        >
          {cards.map(item => {
            return (
              <Box
                id="card3"
                key={nanoid()}
                // key={secCon.index}
                display="flex"
                flexDirection="column"
                mx="auto"
                maxW={{
                  base: '100%',
                  sm: '330px',
                  lg: '370px',
                }}
                position="relative"
              >
                <Link cursor="cursor">
                  <LazyLoadImageComponent
                    src={item.thumbnail.url}
                    title={item.thumbnail.title}
                    alt={item.thumbnail.alt}
                    objectFit="cover"
                    w="100%"
                    minH="210px"
                    maxH={218}
                  />
                </Link>

                <Box
                  w="90%"
                  h={{ base: 235, sm: 240, lg: '235px' }}
                  objectFit="contain"
                  // transform="rotate(-178.76deg)"
                  position="absolute"
                  left="5%"
                  // background={bgColors[index % bgColors.length]}
                  background="#EAB646"
                  outline="1px solid transparent"
                  zIndex="-1"
                  top="0"
                ></Box>

                <Box
                  lineHeight={1.1}
                  fontFamily="'FedraSansStd-A-medium' , sans-serif"
                  fontSize="24px"
                  pt="50px"
                  color="#ffffff"
                  textAlign={'left'}
                >
                  {item.title}
                </Box>
                <Box
                  fontFamily="FedraSansStd-book"
                  fontSize="16px"
                  color="#FFBCBC"
                >
                </Box>

                <Box
                  as="p"
                  borderRadius="5px"
                  my={19}
                  fontFamily="'FedraSansStd-book', sans-serif"
                  fontSize="16px"
                  color="#FFBCBC"
                  className="truncate-text-4"
                >
                  <StructuredTextParser
                    str={render(item.description)}
                    region={region}
                    lang={lang}
                  />
                </Box>
                {item.buttonText && (
                  <Flex>
                    <NextLink
                      href={refineUrlDomain(item?.buttonLink, region, lang)}
                      passHref
                      legacyBehavior>
                      <Link
                        color="#fff"
                        // display="flex"
                        // alignItems="center"
                        fontFamily="FedraSansStd-medium"
                        _hover={{
                          textDecoration: 'none',
                        }}
                      >
                        {item.buttonText}
                      </Link>
                    </NextLink>
                    <Box ml="10px" mt={'7px'}>
                      <svg
                        width="8"
                        height="13"
                        viewBox="0 0 8 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L6.5 6.5L1 12"
                          stroke="white"
                          strokeWidth="2"
                        />
                      </svg>
                    </Box>
                  </Flex>
                )}
              </Box>
            );
          })}
        </SimpleGrid>
      </Box>
    </Box>
  );
};

export default SamskritiOfferingCard;
